"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Virtualizer", {
    enumerable: true,
    get: function() {
        return Virtualizer;
    }
});
const _useVirtualizerStylesstyles = require("./useVirtualizerStyles.styles");
const _useVirtualizer = require("./useVirtualizer");
const _renderVirtualizer = require("./renderVirtualizer");
const Virtualizer = (props)=>{
    const state = (0, _useVirtualizer.useVirtualizer_unstable)(props);
    (0, _useVirtualizerStylesstyles.useVirtualizerStyles_unstable)(state);
    return (0, _renderVirtualizer.renderVirtualizer_unstable)(state);
};
Virtualizer.displayName = 'Virtualizer';
